const schoolMembership = {
  Omep: 'OM',
  EdificiosPublicos: 'EP',
};

export default schoolMembership;
